import React from 'react';

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

export default (props) => {
  return (
    props.config.layout.bannerImageUrl &&
    <div className="banner">
      <Container>
        <Grid container direction="row" justify="space-between" alignItems="flex-end">
          <Grid item><a href="/"><img id="logo-company" src={props.config.layout.bannerImageUrl} alt={props.config.layout.bannerImageAlt} /></a></Grid>
          <Grid item></Grid>
        </Grid>
      </Container>
    </div >
  );
}
